/* The red dot on the header bag is the last path of the cart icon.
   It stays hidden while the link has cartToggle--empty, and that class is
   written only when Liquid renders the header. Add to cart, the cart app
   drawer, and the unpatched fetch in sh-legacy-atc.js all change the cart
   without re-rendering that link, so the dot waited for a reload.

   This file loads before the app scripts. Their fetch and XHR go through
   the wrappers below. Anything that still bypasses them (the iframe fetch)
   calls window.seppSyncHeaderCart, or the SlideCart / Upcart callbacks. */
(function () {
  if (window.seppSyncHeaderCart) return;

  var CART_WRITE = /\/cart\/(?:add|change|update|clear)(?:\.js)?(?:\?|$)/;
  var FOLLOW_UP = [700, 1600];

  var nativeFetch = window.fetch;
  var running = false;
  var pending = false;
  var followUps = [];
  var epoch = 0;

  function write(count) {
    epoch += 1;
    var n = parseInt(count, 10);
    if (isNaN(n) || n < 0) n = 0;
    var label = n > 9 ? '9+' : String(n);

    var toggles = document.querySelectorAll('[data-cart-toggle]');
    for (var i = 0; i < toggles.length; i++) {
      toggles[i].classList.toggle('cartToggle--empty', n === 0);
    }

    var badges = document.querySelectorAll('[data-cart-items-count]');
    for (var j = 0; j < badges.length; j++) {
      badges[j].textContent = label;
    }
  }

  function cartUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart.js';
  }

  function syncNow() {
    if (running) {
      pending = true;
      return;
    }
    if (typeof nativeFetch !== 'function') return;

    running = true;
    var mine = epoch;
    nativeFetch(cartUrl(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (mine !== epoch) return;
        if (cart && typeof cart.item_count !== 'undefined') write(cart.item_count);
      })
      .catch(function () {})
      .then(function () {
        running = false;
        if (!pending) return;
        pending = false;
        syncNow();
      });
  }

  /* Gifts and upsells often land in a second request. Read again after the
     first paint so the dot does not stick on the pre-gift count, and so it
     disappears once an automatic gift is removed with the last paid item. */
  function scheduleSync() {
    syncNow();
    followUps.forEach(clearTimeout);
    followUps = FOLLOW_UP.map(function (delay) {
      return setTimeout(syncNow, delay);
    });
  }

  window.seppSyncHeaderCart = scheduleSync;

  function isCartWrite(url, method) {
    var verb = String(method || 'GET').toUpperCase();
    if (verb === 'GET' || verb === 'HEAD') return false;
    return CART_WRITE.test(String(url || ''));
  }

  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = (init && init.method) || (input && input.method) || 'GET';
      var pendingFetch = nativeFetch.apply(this, arguments);
      if (isCartWrite(url, method)) {
        Promise.resolve(pendingFetch).then(function (res) {
          if (res && res.ok) scheduleSync();
        }, function () {});
      }
      return pendingFetch;
    };
  }

  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__seppCartMethod = method;
    this.__seppCartUrl = url;
    return origOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (isCartWrite(this.__seppCartUrl, this.__seppCartMethod)) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) scheduleSync();
      });
    }
    return origSend.apply(this, arguments);
  };

  function hookCallback(name) {
    var current = window[name];

    function wrap(fn) {
      if (typeof fn === 'function' && fn.__seppHeaderCart) return fn;
      function wrapped(cart) {
        if (typeof fn === 'function') {
          try { fn.apply(this, arguments); } catch (e) {}
        }
        if (cart && typeof cart.item_count === 'number') write(cart.item_count);
        scheduleSync();
      }
      wrapped.__seppHeaderCart = true;
      return wrapped;
    }

    try {
      Object.defineProperty(window, name, {
        configurable: true,
        enumerable: true,
        get: function () { return current; },
        set: function (fn) { current = wrap(fn); },
      });
    } catch (e) {
      return;
    }

    if (typeof current === 'function') window[name] = current;
  }

  function hookAfter(name) {
    var current = window[name];

    function wrap(fn) {
      if (typeof fn !== 'function' || fn.__seppHeaderCart) return fn;
      function wrapped() {
        var result = fn.apply(this, arguments);
        Promise.resolve(result).then(scheduleSync, scheduleSync);
        return result;
      }
      wrapped.__seppHeaderCart = true;
      return wrapped;
    }

    try {
      Object.defineProperty(window, name, {
        configurable: true,
        enumerable: true,
        get: function () { return current; },
        set: function (fn) { current = wrap(fn); },
      });
    } catch (e) {
      return;
    }

    if (typeof current === 'function') window[name] = current;
  }

  hookCallback('SLIDECART_UPDATED');
  hookCallback('upcartOnCartUpdated');
  hookAfter('SLIDECART_UPDATE');
  hookAfter('upcartRefreshCart');
  hookAfter('upcartUpdateCart');

  var upcartSubscribed = false;
  var upcartTries = 0;
  var upcartTimer = setInterval(function () {
    upcartTries += 1;
    if (upcartSubscribed || upcartTries > 80) {
      clearInterval(upcartTimer);
      return;
    }
    if (typeof window.upcartSubscribeCartUpdated !== 'function') return;
    upcartSubscribed = true;
    clearInterval(upcartTimer);
    window.upcartSubscribeCartUpdated(function (cart) {
      if (cart && typeof cart.item_count === 'number') write(cart.item_count);
      scheduleSync();
    });
  }, 250);

  document.addEventListener('theme:cart:change', scheduleSync);
  document.addEventListener('theme:cart:refresh', scheduleSync);
  document.addEventListener('sc:cart:updated', scheduleSync);

  /* Capture runs before the cart app stops the theme submit. The timed
     reads cover an add that never passes through fetch or XHR. */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (!target.closest('button[name="add"], .product-form__submit, [data-add-to-cart]')) return;
    scheduleSync();
  }, true);
})();
